import { useOutlet } from "react-router-dom";

export const PublicLayout = () => {
  const outlet = useOutlet();

  return (
    <div>
      {outlet}
    </div>
  );
};